import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { Invoice } from "domain/entities/invoice";
import invoiceRepository from "infra/repositories/invoice-repository";
import { Logger } from "../../infra/logger/logger";

export const useUpdateInvoiceMutation = () => {
  const logger = Logger.getInstance();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: Invoice) => {
      const result = await invoiceRepository.update(data);
      return result;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["invoices", {}] });
    },
    onError: (error: any) => {
      if (error instanceof AxiosError) {
        logger.error(
          error.response?.data.metadata.errors[0],
          error.response?.data.metadata
        );
        throw new Error(error.response?.data.metadata.errors);
      }
      throw error;
    },
  });
};

export const useInvoicesById = (id?: string) => {
  const logger = Logger.getInstance();

  return useQuery({
    queryKey: ["invoice", id],
    queryFn: async () => {
      try {
        if (!id) return;
        const result = await invoiceRepository.getById(id);

        return result;
      } catch (error: any) {
        if (error instanceof AxiosError) {
          logger.error(
            error.response?.data.metadata.errors[0],
            error.response?.data.metadata
          );
          throw new Error(error.response?.data.metadata.errors);
        }
        throw error;
      }
    },
    enabled: !!id,
    retry: Number(process.env.REACT_APP_QUERY_RETRY) || 5,
    staleTime: 0,
  });
};

